import * as sqtAxiosConfig from '@client/axios/sqt.axiosConfig'

const axiosInstance = sqtAxiosConfig.getNewInstance(`${global.SEQITRACKER_API_URL}/hr`, { exclude: { paths: ['/users', '/reports'] } });

const clearCache = async function () {
  await axiosInstance.cache.clear();
}

const getUsers = async function () {
  return (await axiosInstance.get('/users')).data;
}

const getTeams = async function () {
  return (await axiosInstance.get('/teams')).data;
}

const getInternalProjects = async function () {
  return (await axiosInstance.get('/internalProjects')).data;
}

const getEmployeesData = async function(year, month) {
  return (await axiosInstance.get(`/employees/${year}/${month}`)).data;
}

const createUser = async function(newUserObject) {
  await axiosInstance.post('/users', newUserObject);
}

const updateUser = async function(userID, updatedUserObject) {
  await axiosInstance.put(`/users/${userID}`, updatedUserObject);
}

const endUserEmployment = async function(userID, endDate, exemptFrom) {
  await axiosInstance.put(`/endUserEmployment/${userID}`, {endDate, exemptFrom});
}

const generateAbsencesReport = async function (from, to) {
  return (await axiosInstance.get(`/reports/absences?from=${from}&to=${to}`, {
    headers: {
      'accept': global.HTTP_HEADER.ACCEPT.TEXTCSV
    }
  })).data;
}

const generateHomeOfficeReport = async function (from, to) {
  return (await axiosInstance.get(`/reports/homeoffice?from=${from}&to=${to}`, {
    headers: {
      'accept': global.HTTP_HEADER.ACCEPT.TEXTCSV
    }
  })).data;
}

const generateZeitsaldenReport = async function (month, year) {
  return (await axiosInstance.get(`/reports/zeitsalden?month=${month}&year=${year}`, {
    headers: {
      'accept': global.HTTP_HEADER.ACCEPT.TEXTCSV
    }
  })).data;
}

const calcUserKPIs = async function (userID, year) { 
  return (await axiosInstance.get(`/userKPIs/${year}/${userID}`)).data;
}



export {
  clearCache,
  createUser,
  getUsers,
  getTeams,
  getInternalProjects,
  getEmployeesData,
  updateUser,
  endUserEmployment,
  generateAbsencesReport,
  generateHomeOfficeReport,
  generateZeitsaldenReport,
  calcUserKPIs
}

